import React from "react";

/**
 * Dial codes + ISO 3166-1 alpha-2 for flag images (PNG).
 * Images: https://flagcdn.com
 */
export const CONTACT_DIAL_OPTIONS = [
  { code: "+966", iso: "sa" },
  { code: "+971", iso: "ae" },
  { code: "+973", iso: "bh" },
  { code: "+965", iso: "kw" },
  { code: "+974", iso: "qa" },
  { code: "+968", iso: "om" },
  { code: "+962", iso: "jo" },
  { code: "+961", iso: "lb" },
  { code: "+964", iso: "iq" },
  { code: "+20", iso: "eg" },
  { code: "+212", iso: "ma" },
  { code: "+216", iso: "tn" },
  { code: "+249", iso: "sd" },
  { code: "+1", iso: "us" },
  { code: "+44", iso: "gb" },
  { code: "+49", iso: "de" },
  { code: "+33", iso: "fr" },
  { code: "+90", iso: "tr" },
];

export const FLAGCDN_BASE = "https://flagcdn.com";

export function ContactDialFlagImg({ iso, className }) {
  const code = (iso || "xx").toLowerCase();
  return (
    <img
      className={className}
      src={`${FLAGCDN_BASE}/h24/${code}.png`}
      srcSet={`${FLAGCDN_BASE}/h48/${code}.png 2x`}
      width={28}
      height={21}
      alt=""
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
    />
  );
}

export function dialMetaForCode(code) {
  return CONTACT_DIAL_OPTIONS.find((o) => o.code === code) ?? CONTACT_DIAL_OPTIONS[0];
}

/** Split a stored full phone (e.g. "+966 501234567") into dial code + national digits for editing. */
export function parsePhoneForEdit(full) {
  const s = String(full || "").trim();
  if (!s) return { dialCode: "+966", national: "" };
  const sorted = [...CONTACT_DIAL_OPTIONS].sort((a, b) => b.code.length - a.code.length);
  for (const { code } of sorted) {
    if (s.startsWith(code)) {
      const rest = s
        .slice(code.length)
        .trim()
        .replace(/\D/g, "")
        .replace(/^0+/, "");
      return { dialCode: code, national: rest };
    }
  }
  const digits = s.replace(/\D/g, "").replace(/^0+/, "");
  return { dialCode: "+966", national: digits };
}
